/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GoalRequirementResponse } from './GoalRequirementResponse';

/**
 * A consistency score requirement fulfillment
 */
export type RequirementFulfillmentResponse = {
    /**
     * The requirement type
     */
    type: RequirementFulfillmentResponse.type;
    /**
     * The score threshold required to meet this requirement
     */
    threshold: number;
    /**
     * The set of goal requirements that must be met
     */
    goalRequirements: Array<GoalRequirementResponse>;
    fulfilled?: boolean;
};

export namespace RequirementFulfillmentResponse {

    /**
     * The requirement type
     */
    export enum type {
        GLP1_REFILL = 'GLP1_REFILL',
    }


}

